var map = {
	"./上海/官网/3.jpg": 60036,
	"./北京/官网/3.jpg": 49777,
	"./南京/官网/3.jpg": 61475,
	"./广州/官网/3.jpg": 34254,
	"./成都/官网/3.jpg": 56376,
	"./杭州/官网/3.jpg": 66550,
	"./武汉/官网/3.jpg": 49708,
	"./深圳/官网/3.jpg": 3894,
	"./西安/官网/3.jpg": 83365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22947;